import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";

// Brand Clerk here once: it styles sign-in, sign-up and the user menu.
const appearance = {
  variables: {
    colorPrimary: "#651F38",
    colorPrimaryForeground: "#FFFFFF",
    colorBackground: "#FFFFFF",
    colorForeground: "#242127",
    colorInput: "#FFFFFF",
    colorInputForeground: "#242127",
    colorBorder: "#E6DDD5",
    fontFamily: "'DM Sans', sans-serif",
    borderRadius: "14px",
  },
};

const localization = {
  locale: "fr-FR",
  formButtonPrimary: "Continuer",
  formFieldLabel__emailAddress: "Adresse email",
  formFieldLabel__password: "Mot de passe",
  formFieldAction__forgotPassword: "Mot de passe oublié ?",
  dividerText: "ou",
  signIn: {
    start: { title: "Connexion à UGC GO", subtitle: "Heureuse de te revoir ! Connecte-toi pour continuer.", actionText: "Pas encore de compte ?", actionLink: "Créer un compte" },
    password: { title: "Ton mot de passe", subtitle: "Saisis le mot de passe de ton compte", actionLink: "Utiliser une autre méthode" },
    emailCode: { title: "Vérifie tes emails", subtitle: "pour continuer sur UGC GO", formTitle: "Code de vérification", resendButton: "Renvoyer le code" },
  },
  signUp: {
    start: { title: "Crée ton compte UGC GO", subtitle: "Pour retrouver ton parcours sur tous tes appareils.", actionText: "Déjà un compte ?", actionLink: "Se connecter" },
    emailCode: { title: "Vérifie ton email", subtitle: "Saisis le code reçu par email", formTitle: "Code de vérification", resendButton: "Renvoyer le code" },
  },
  userButton: { action__manageAccount: "Gérer mon compte", action__signOut: "Se déconnecter" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Starts Clerk from the backend's runtime config, so deploy's live keys need no rebuild.
export default function ClerkAuthProvider({ children, fallback = null }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  // Clerk-free routes only (home) while sign-in is loading or unavailable.
  if (!config) return fallback(unavailable);
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      localization={localization}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/mon-espace"
      signUpFallbackRedirectUrl="/mon-espace"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
